import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_parent",
			dependent_visible: "q_parent_attend_college",
			dependent_visible_values: ["Y"],
			options: [
				{
					value: "No Degree",
					text: "No Degree Earned"
				},
				{
					value: "Trade",
					text: "Business or Trade School"
				},
				{
					value: "Associates",
					text: "Associates (2-yr degree)"
				},
				{
					value: "Bachelors",
					text: "Bachelors (4-yr degree)"
				},
				{
					value: "Masters",
					text: "Masters"
				},
				{
					value: "MBA",
					text: "MBA (Business)"
				},
				{
					value: "JD (Law)",
					text: "JD (Law)"
				},
				{
					value: "PHD",
					text: "PHD (Doctorate)"
				},
				{
					value: "Medicine",
					text: "MD/DO/DVM/DDS (Medicine)"
				}
			]
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
